import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import HowToReachUs from "../components/GetInTouch/ReachUsSection";
import LocationSection from "../components/GetInTouch/LocationSection";
import SendMessageForm from "../components/GetInTouch/SendUsMessageForm";
import LandingHero from "../components/Common/LandingHero";
import data from "../content.json";
const GetInTouch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formRef = useRef(null);

  // Auto-scroll to form when navigating with query parameter
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const purpose = urlParams.get("purpose");

    // scroll to the form after a short delay
    if (purpose && formRef.current) {
      // Small delay to ensure the page has fully rendered
      setTimeout(() => {
        formRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [location.search]);

  const heroButtons = [
    {
      label: "Contact Us",
      className: "btn-secondary",
      onClick: () => {
        formRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      },
    },
  ];

  useEffect(() => {
    if (location.hash === "#contactForm" && formRef.current) {
      setTimeout(() => {
        formRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [location]);

  return (
    <>
      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.contact.hero} />
      </div>

      <div className="relative z-10  overflow-visible">
        {/* Hero Section */}
        {/* <HeroSection
          backgroundImage="/assets/getInTouch/heroSection.svg"
          title="Driving Digital Transformation for Modern Enterprises"
          subtitle="Avexa Systems helps healthcare organizations modernize systems, streamline workflows, and harness data through digital platforms and intelligent solutions—enabling smarter, connected, future-ready healthcare."
          buttons={heroButtons}
          textAlign="center"
          height="h-screen"
        /> */}

        <div className="relative z-10 overflow-visible ">
          <HowToReachUs />
        </div>

        <section id="location-section">
          <LocationSection />
        </section>

        {/* Add ref to the form section */}
        <div ref={formRef} id="contactForm">
          <SendMessageForm />
        </div>
        <div className="h-16 md:h-20 lg:h-24 bg-white"></div>
      </div>
    </>
  );
};

export default GetInTouch;
